import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import React from 'react';
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min";
import WhatsAppButton from './Components/Whatsapp/WhatsAppButton'; // Import the WhatsAppButton component
import Body from "./Components/BodyComp/body";
import NavComp from "./Components/MainComp/NavComp";
import FooterComp from "./Components/MainComp/FooterComp";
import ContactUs from "./Components/ContactusComp/contactus";
import AboutUs from "./Components/AboutusComp/aboutus";
import Booking from './Components/BookingComp/booking';
import FAQs from './Components/FAQsComp/faqs';
import TermsAndConditions from './Components/InfoComp/terms';
import PrivacyAndPolicy from './Components/InfoComp/privacy';
import Feedback from './Components/Whatsapp/feedback';
import Gallery from './Components/GalleryComp/gallery';



import BalloonRides from './Components/ThingsComp/balloon-rides';
import Surfing from './Components/ThingsComp/surfing';
import Rafting from './Components/ThingsComp/rafting';
import MountainAndHiking from './Components/ThingsComp/mountain-and-hiking';
import BoatSafari from './Components/ThingsComp/boat-safari';
import WildLife from './Components/ThingsComp/wildlife';
import JetSkiing from './Components/ThingsComp/jet-skiing';
import BirdWatching from './Components/ThingsComp/bird-watching';




import PrivateRoute from './Utils/PrivateRoute';
import ForgotPassword from './Components/LoginComp/ForgotPassword';
import SignIn from './Components/LoginComp/signin';
import SignUp from './Components/LoginComp/signup';
import UserProfile from './Components/UserComp/userprofile';
import ViewMyBookings from './Components/UserComp/view-my-bookings';
import AdminPanel from './Components/AdminComp/adminpanel';
import Promotions from './Components/UserComp/promotions';
import DriverPanel from './Components/DriverComp/driver-panel';



import BookingFloat from './Components/Whatsapp/bookingfloat';
import ScrollToTop from './ScrollComp/ScrollToTop';
// import Snow from './Components/SnowFlake/snow';

function App() {
  return (
    <Router>
    <ScrollToTop />
    <NavComp />
    <Routes>
      <Route path="/" element={<Body />} />
      <Route path="/aboutus" element={<AboutUs />} />
      <Route path="/contactus" element={<ContactUs />} />
      <Route path="/booking" element={<Booking />} />
      <Route path="/faqs" element={<FAQs />} />
      <Route path="/privacy" element={<PrivacyAndPolicy />} />
      <Route path="/terms" element={<TermsAndConditions />} />
      <Route path="/gallery" element={<Gallery />} />

      <Route path="/surfing" element={<Surfing />} />
      <Route path="/rafting" element={<Rafting />} />
      <Route path="/wildlife" element={<WildLife />} />
      <Route path="/mountain-and-hiking" element={<MountainAndHiking />} />
      <Route path="/jet-skiing" element={<JetSkiing />} />
      <Route path="/boat-safari" element={<BoatSafari />} />
      <Route path="/bird-watching" element={<BirdWatching />} />
      <Route path="/balloon-rides" element={<BalloonRides />} />


      <Route path="/signin" element={<SignIn />} />
        <Route path="/signup" element={<SignUp />} />
        <Route path="/ForgotPassword" element={<ForgotPassword />} />
        <Route path='/view-my-bookings' element={<ViewMyBookings />} />
        <Route path='/promotions' element={<Promotions />} />
   




        <Route
          path="/userprofile"
          element={
            <PrivateRoute>
                <UserProfile />
            </PrivateRoute>
          }
        />

                    
                     
        
                <Route
          path="/adminpanel"
          element={
            <PrivateRoute>
              <AdminPanel />
            </PrivateRoute>
          }
        />




                <Route
          path="/driver-panel"
          element={
            <PrivateRoute>
              <DriverPanel />
            </PrivateRoute>
          }
        />




  
    </Routes>
    <FooterComp /> 
           
    <WhatsAppButton /> 
    <BookingFloat />
    {/* <Snow /> */}
  </Router>
  );
}

export default App;
